import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontFamilies, fontSizes, lineHeights, fontWeights, palette, breakpoints, borderRadiuses,
}: Theme) => ({
  root: {
    borderRadius: borderRadiuses.md,
    border: `2px solid ${palette.grey['200']}`,
    boxShadow: 'none',
    background: palette.common.white,
    [breakpoints.up('sm')]: {
      height: '100%',
    },
  },
  title: {
    margin: 0,
    padding: '20px 24px',
    color: palette.text.secondary,
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.sm,
    lineHeight: 1.5,
    fontWeight: fontWeights.medium,
  },
  description: {
    padding: '20px 24px',
    borderTop: `2px solid ${palette.grey['200']}`,
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  listItem: {
    marginBottom: 12,
    color: palette.text.primary,
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.xxs,
    lineHeight: lineHeights.xs,
    [breakpoints.up('sm')]: {
      marginBottom: 16,
      fontSize: fontSizes.xs,
      lineHeight: lineHeights.md,
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  link: {
    color: palette.text.primary,
    letterSpacing: 'normal',
    textAlign: 'left',
    textDecoration: 'underline',
    '&:focus': {
      outline: `1px dotted ${palette.text.primary}`,
    },
    '& span': {
      fontWeight: fontWeights.regular,
    },
  },
}));
